<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <div>
    number
  </div>
</template>

<script>
export default {
  dependencies: ['questionType'],
  computed: {}
}
</script>
